import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8vwwymqtm: FaireProductEntity = {
  token: "p_g8vwwymqtm",
  type: "product",
  name: "Opal French Ring Steel 18K Gold Vintage Luxury S5P021",
  brandToken: "b_vzcwf2s2c8",
  brandName: "alberalkirk",
  imageUrl:
    "https://cdn.faire.com/fastly/a310b3cce8fdba61f228e7ba53380b01e7d5890b8fddb95d1b1dccd3ad64aa35.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e80056b473ec88938a168961fba2c28cd614cd242f36ec21033a6f6204a0bea.jpeg",
    "https://cdn.faire.com/fastly/047773dc749c935a1db3cade8d1a91fd0495113d8961be79e5b45f24471f6de1.jpeg",
    "https://cdn.faire.com/fastly/bc7886f41a17a574ef27e6389b92196ae7e4c763121e881ea34591351f5dda90.jpeg",
    "https://cdn.faire.com/fastly/e2f21a66f318d8e313959b33b45d2d15c5344da7a3f925afe785b7b6a9ab8fa9.jpeg",
  ],
  priceDollars: 12.82,
  description:
    "Material: \n * Stainless Steel \n\n Weight: \n * 10g \n\n Feature: \n * Genuine Opal Stone Centerpiece \n * French Vintage Inspired Setting \n * 18K Gold Plated Finish \n * Timeless Elegant Silhouette \n * Substantial Comfort Fit \n\n Note: \n * Opal Care: Avoid water & extreme temperatures \n * Gold plating requires gentle cleaning \n * Natural opal color play varies ",
  tags: [],
  msrpDollars: 25.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:09.025Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
